<template>
   <div class="notice_popup cp_prj">
        <div class="close">
            <img src="/images/close.png" alt="닫기" @click="$emit('close', false)"/>
        </div>
        <div class="name">
            {{data.mberNm}}
            <span>({{data.gender | gender}})</span>
        </div>
        <div class="tit">완료 프로젝트</div>
        <div class="scroll-box cp_prj">
            <div class="list-box" v-for="item in data.list" :key="item.projectSeq + '_' + item.evalTabSeq">
                <div class="prj_outline">
                    <div class="left">
                        <div class="regi mr-5">
                            <!-- <div class="outline"> -->
                            <div class="outline" style="display: inline-flex;justify-content: center;align-items: center;">
                                <div class="label">
                                    <p>프 로 젝 트 명</p>
                                </div>
                                <div class="value prj" style="width: 460px; text-overflow: ellipsis;">{{item.projectNm}}</div>
                            </div>
                            <div class="outline">
                                <div class="label">
                                    <p>개 요</p>
                                </div>
                                <div class="value text">{{item.projectDtlDesc}}</div>
                            </div>
                            <div class="outline">
                                <div class="label">
                                    <p>고 객 사</p>
                                </div>
                                <div style="display: inline-flex;">
                                    <div class="value" style="display: inline-block; white-space: nowrap;">{{item.clientNm}}</div>
                                    <template v-if="item.projectLocCont">
                                        <img src="/images/location.png" alt="위치"/><div class="value location">{{item.projectLocCont}}</div>
                                    </template>
                                </div>
                            </div>
                            <div class="outline" style="display: inline-flex;">
                                <div class="label">
                                    <p>산 업 분 야</p>
                                </div>
                                <!-- <div class="value">{{item.corpMgrMberNm}}</div> -->
                                <div class="value" style="width: 460px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"><SelectComp type="text" cdId="PRO105" :value="item.indtypeFilterCd"/> / <SelectComp type="text" cdId="PRO143" :value="item.indtypeClassCd"/></div>
                            </div>                             

                        </div>
                        <div class="int_box">
                            <div class="outline">
                                <div class="label">
                                    <p>수 행 사</p>
                                </div>
                                <div class="value">{{item.corpNm}}</div>
                            </div>
                            <div class="outline">
                                <div class="label">
                                    <p>담 당 자</p>
                                </div>
                                <div class="value">{{item.corpMgrMberNm}}</div>
                            </div>
                            <div class="outline">
                                <div class="label">
                                    <p>개 발 기 간</p>
                                </div>
                                <div class="value">{{item.joinStartYyyymmdd | date('yyyy.MM.dd')}} ~ {{item.joinEndYyyymmdd | date('yyyy.MM.dd')}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="right">
                        <p>클라이언트 평가</p>
                        <div class="pt-12" v-if="!item.itemDivGrade">평가 결과가 없습니다.</div>
                        <div v-else class="star-evl" v-for="(str, idx) in item.itemDivGrade.split('|')" :key="idx">                            
                            <SelectComp tagName="p" type="text" :value="str.split(':')[0]" cdId="PRO110"/>
                            <grade-img type="CLIENT_EVAL_CST" :grade="str.split(':')[1]"/>
                        </div>
                    </div>
                </div>
                <!-- 프로젝트 평가 -->
                <div class="review" v-if="item.evaluatorLoginId">
                    <div class="layout">
                        <div class="photo">
                            <img src="/images/cstom_photo.png" alt="사진"/>
                        </div>
                        <div class="cstom_name">수행사<span>{{item.evaluatorLoginId}}</span></div>
                    </div>
                    <div class="layout">
                        <div class="list cstom eval">
                            <p>프로젝트 평가<span class="date">{{item.evalYyyymmdd | date('yyyy.MM.dd')}}</span></p>
                            <nbsp tagName="span" :value="item.overallOpinCont"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
import gradeImg from "@/components/highpro/GradeImg.vue";
export default {
	components: { gradeImg },
    props: ['param'],
    data() {
        return {
            data: {},
        };
    }, 
    mounted(){
        //console.log('PRF301P06', 'mounted', this.param);
        if(this.param.tecMberSeq){
            this.$.httpPost('/api/mem/prf/getTecEval', {tecMberSeq: this.param.tecMberSeq, prjtStats: this.param.prjtStats, nmViewYn: this.param.nmViewYn, evalYn:'N'})
                .then(res => {
                    this.data = res.data;
                });
        } else {
            alert('파라미터를 확인해 주세요.');
            this.$emit('close', false);
        }
    },
    methods: {
    },
};
</script>